var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAuthorized)?_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.logout($event)}}},[_vm._v("Logout")]):_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.login($event)}}},[_vm._v("Login")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1e21dda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginWithAmazon.vue
// module id = null
// module chunks = 